<main>
  <loading-overlay [isLoading]="isLoading()"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Business_Lot_Numbers_Title' | translateWF: 'Business Lot Numbers' }}</h1>
      </div>
    </div>
    <p-panel header="Manufacturers & Providers">
      <ng-template pTemplate="icons">
        <!-- Search filters -->
        <div class="row-sm-start-center">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-search"></i></p-inputgroup-addon>
            <input pInputText type="text" [ngModel]="nameFilter()" (ngModelChange)="onNameFilterChange($event)" placeholder="Search by business name..." />
          </p-inputgroup>
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-tag"></i></p-inputgroup-addon>
            <input pInputText type="text" [ngModel]="lotNumberFilter()" (ngModelChange)="lotNumberFilter.set($event)" placeholder="Filter by lot number..." />
          </p-inputgroup>
        </div>
      </ng-template>
      <p-card data-variant="compact">
        <p-table [value]="filteredBusinesses()" [loading]="isLoading()">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 8rem">Code</th>
              <th>Name</th>
              <th style="width: 14rem">Types</th>
              <th>Lot Numbers</th>
              <th style="width: 6rem"></th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-business>
            <tr>
              <td>{{ business.code || '-' }}</td>
              <td>{{ business.name }}</td>
              <td>
                <div class="flex flex-wrap gap-1">
                  <p-tag *ngFor="let type of business.businessTypes" [value]="businessTypeLabels[type] || type" severity="info"></p-tag>
                </div>
              </td>
              <td>
                <div class="flex flex-wrap gap-1 align-items-center">
                  <p-tag *ngFor="let lot of getPreviewLotNumbers(business)" [value]="lot" severity="secondary"></p-tag>
                  <p-tag
                    *ngIf="getExtraCount(business) > 0"
                    [value]="'+' + getExtraCount(business) + ' more'"
                    severity="secondary"
                    [style]="{ cursor: 'pointer' }"
                    (click)="showOverflow($event, business)"
                  ></p-tag>
                  <span *ngIf="!business.lotNumbers?.length" class="text-gray-400 text-sm"> No lot numbers </span>
                </div>
              </td>
              <td class="!text-end">
                <p-button *ngIf="canEdit()" icon="pi pi-pencil" variant="text" pTooltip="Edit Lot Numbers" tooltipPosition="bottom" (onClick)="openModal(business)" />
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5" class="text-center py-4">No businesses found</td>
            </tr>
          </ng-template>
        </p-table>

        <p-paginator
          [rows]="pageSize"
          [totalRecords]="totalRecords()"
          [first]="(currentPage - 1) * pageSize"
          (onPageChange)="onPageChange($event)"
          [rowsPerPageOptions]="[25, 50, 100]"
          class="mt-4"
        ></p-paginator>
      </p-card>
    </p-panel>
  </div>
</main>

<!-- Single popover for overflow lot numbers -->
<p-popover #lotOverflow appendTo="body">
  <div class="flex flex-wrap gap-2 p-1" style="max-width: 22rem">
    <p-tag *ngFor="let lot of overflowLotNumbers()" [value]="lot" severity="secondary"></p-tag>
  </div>
</p-popover>
